<div class="page-container" [testId]="'inbound-reason-create-page'">
  <div class="page-header" [testId]="'inbound-reason-create-header'">
    <div class="header-content">
      <button nz-button nzType="text" class="back-button" (click)="cancel()" [testId]="'inbound-reason-create-back-button'">
        <i nz-icon nzType="arrow-left" [testId]="'inbound-reason-create-back-icon'"></i>
      </button>
      <div class="title-section">
        <h1>
          {{ (reasonId ? 'servicenumber.inbound-reason.edit.title' : 'servicenumber.inbound-reason.create.title') | i18n }}
        </h1>
        <p>
          {{ (reasonId ? 'servicenumber.inbound-reason.edit.subtitle' : 'servicenumber.inbound-reason.create.subtitle') | i18n }}
        </p>
      </div>
    </div>
    <div class="header-actions" [testId]="'inbound-reason-create-header-actions'">
      <button
        nz-button
        nzType="primary"
        type="button"
        class="save-button"
        (click)="save()"
        [nzLoading]="saving"
        [testId]="'inbound-reason-create-save'"
      >
        {{ (reasonId ? 'common.save' : 'servicenumber.inbound-reason.create.button') | i18n }}
      </button>
    </div>
  </div>

  <div class="form-card" [testId]="'inbound-reason-create-card'">
    <form nz-form nzLayout="vertical" [formGroup]="form" class="reason-form" [testId]="'inbound-reason-create-form'">
      <div class="section-card" [testId]="'inbound-reason-create-basic-section'">
        <div class="section-title">
          <span class="section-label">{{ 'servicenumber.inbound-reason.form.basic-info' | i18n }}</span>
        </div>
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-name-col'">
            <nz-form-item class="form-item">
              <nz-form-label nzRequired [testId]="'inbound-reason-create-name-label'">{{
                'servicenumber.inbound-reason.form.name' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzErrorTip]="'servicenumber.inbound-reason.form.name-required' | i18n"
                [testId]="'inbound-reason-create-name-control'"
              >
                <input
                  nz-input
                  formControlName="name"
                  maxlength="50"
                  [placeholder]="'servicenumber.inbound-reason.form.name-placeholder' | i18n"
                  [testId]="'inbound-reason-create-name-input'"
                />
                <div class="char-count">{{ $any(form.get('name')?.value)?.length || 0 }}/50</div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-labels-col'">
            <nz-form-item class="form-item">
              <nz-form-label [testId]="'inbound-reason-create-labels-label'">{{
                'servicenumber.inbound-reason.form.labels' | i18n
              }}</nz-form-label>
              <nz-form-control [testId]="'inbound-reason-create-labels-control'">
                <nz-select
                  formControlName="labelIds"
                  nzMode="multiple"
                  nzShowSearch
                  nzAllowClear
                  [nzLoading]="labelLoading"
                  [nzPlaceHolder]="'servicenumber.inbound-reason.form.labels-placeholder' | i18n"
                  [testId]="'inbound-reason-create-labels-select'"
                >
                  <nz-option *ngFor="let label of labelOptions" [nzValue]="label.id" [nzLabel]="label.name" />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-type-col'">
            <nz-form-item class="form-item">
              <nz-form-label nzRequired [testId]="'inbound-reason-create-type-label'">{{
                'servicenumber.inbound-reason.form.type' | i18n
              }}</nz-form-label>
              <nz-form-control
                [nzErrorTip]="'servicenumber.inbound-reason.form.type-required' | i18n"
                [testId]="'inbound-reason-create-type-control'"
              >
                <nz-select
                  formControlName="type"
                  [nzPlaceHolder]="'servicenumber.inbound-reason.form.type-placeholder' | i18n"
                  [testId]="'inbound-reason-create-type-select'"
                >
                  <nz-option *ngFor="let opt of typeOptions" [nzValue]="opt.value" [nzLabel]="opt.labelI18nKey | i18n" />
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-desc-col'">
            <nz-form-item class="form-item">
              <nz-form-label [testId]="'inbound-reason-create-desc-label'">{{
                'servicenumber.inbound-reason.form.description' | i18n
              }}</nz-form-label>
              <nz-form-control [testId]="'inbound-reason-create-desc-control'">
                <textarea
                  nz-input
                  formControlName="description"
                  maxlength="100"
                  [placeholder]="'servicenumber.inbound-reason.form.description-placeholder' | i18n"
                  [nzAutosize]="{ minRows: 3, maxRows: 6 }"
                  [testId]="'inbound-reason-create-desc-textarea'"
                ></textarea>
                <div class="char-count">{{ $any(form.get('description')?.value)?.length || 0 }}/100</div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-business-id-col'">
            <nz-form-item class="form-item">
              <nz-form-label [testId]="'inbound-reason-create-business-id-label'">{{
                'servicenumber.inbound-reason.form.business-id' | i18n
              }}</nz-form-label>
              <nz-form-control [testId]="'inbound-reason-create-business-id-control'">
                <input
                  nz-input
                  formControlName="businessId"
                  [placeholder]="'servicenumber.inbound-reason.form.business-id-placeholder' | i18n"
                  [testId]="'inbound-reason-create-business-id-input'"
                />
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>

      <div class="section-card" [testId]="'inbound-reason-create-config-section'">
        <div class="section-title">
          <span class="section-icon">
            <i nz-icon nzType="setting"></i>
          </span>
          <span class="section-label">{{ 'servicenumber.inbound-reason.form.config' | i18n }}</span>
        </div>

        <!-- 生效期限 -->
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-validity-type-col'">
            <nz-form-item class="form-item">
              <nz-form-label [testId]="'inbound-reason-create-validity-label'">{{
                'servicenumber.inbound-reason.form.validity' | i18n
              }}</nz-form-label>
              <nz-form-control [testId]="'inbound-reason-create-validity-control'">
                <nz-radio-group
                  class="validity-radio-group"
                  formControlName="validityType"
                  [testId]="'inbound-reason-create-validity-radio-group'"
                >
                  <div class="validity-row">
                    <label nz-radio nzValue="permanent" [testId]="'inbound-reason-create-validity-permanent'">{{
                      'servicenumber.inbound-reason.validity.permanent' | i18n
                    }}</label>
                  </div>
                  <div class="validity-row validity-row-custom" [testId]="'inbound-reason-create-validity-date-row'">
                    <label nz-radio nzValue="custom" [testId]="'inbound-reason-create-validity-custom'">{{
                      'servicenumber.inbound-reason.validity.custom' | i18n
                    }}</label>
                    <nz-date-picker
                      formControlName="expireTime"
                      nzFormat="yyyy-MM-dd"
                      [nzPlaceHolder]="'servicenumber.inbound-reason.form.validity-date-placeholder' | i18n"
                      [nzDisabledDate]="disablePastDates"
                      nzAllowClear
                      [nzDisabled]="form.get('validityType')?.value !== 'custom'"
                      class="validity-date-picker"
                      [testId]="'inbound-reason-create-validity-date-picker'"
                    />
                  </div>
                  <div
                    class="validity-error"
                    *ngIf="
                      form.get('validityType')?.value === 'custom' &&
                      form.get('expireTime')?.invalid &&
                      (form.get('expireTime')?.dirty || form.get('expireTime')?.touched)
                    "
                    [testId]="'inbound-reason-create-validity-date-error'"
                  >
                    {{ 'servicenumber.inbound-reason.form.validity-date-required' | i18n }}
                  </div>
                </nz-radio-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <!-- 正則開關 -->
        <div nz-row [nzGutter]="16" class="form-row">
          <div nz-col [nzSpan]="24" [testId]="'inbound-reason-create-regex-enabled-col'">
            <nz-form-item class="form-item">
              <div class="switch-row">
                <div class="switch-info">
                  <nz-form-label [testId]="'inbound-reason-create-regex-enabled-label'">
                    {{ 'servicenumber.inbound-reason.form.regex-enabled' | i18n }}
                  </nz-form-label>
                  <div class="switch-description" [testId]="'inbound-reason-create-regex-enabled-desc'">
                    {{ 'servicenumber.inbound-reason.form.regex-enabled-desc' | i18n }}
                  </div>
                </div>
                <nz-form-control [testId]="'inbound-reason-create-regex-enabled-control'">
                  <nz-switch
                    formControlName="regexEnabled"
                    (ngModelChange)="onRegexEnabledChange($event)"
                    [testId]="'inbound-reason-create-regex-enabled-switch'"
                  />
                </nz-form-control>
              </div>
            </nz-form-item>
          </div>
        </div>

        <!-- 正則規則清單（開關開啟時顯示） -->
        <div
          *ngIf="form.get('regexEnabled')?.value"
          nz-row
          [nzGutter]="16"
          class="form-row regex-rules-row"
          [testId]="'inbound-reason-create-regex-rules-container'"
        >
          <div nz-col [nzSpan]="24">
            <nz-form-item class="form-item">
              <nz-form-label nzRequired [testId]="'inbound-reason-create-regex-rules-label'">
                {{ 'servicenumber.inbound-reason.form.regex-rules' | i18n }} ({{ regexRulesArray.length }}/20)
              </nz-form-label>
              <nz-form-control>
                <div class="regex-rules-list" [testId]="'inbound-reason-create-regex-rules-list'">
                  <div
                    *ngFor="let ruleCtrl of regexRulesArray.controls; let i = index"
                    class="regex-rule-item"
                    [testId]="'inbound-reason-create-regex-rule-item-' + i"
                  >
                    <div class="regex-rule-input-group">
                      <input
                        nz-input
                        [formControl]="$any(ruleCtrl)"
                        maxlength="500"
                        [placeholder]="'servicenumber.inbound-reason.form.regex-rules-placeholder' | i18n"
                        [testId]="'inbound-reason-create-regex-rule-input-' + i"
                      />
                      <button
                        nz-button
                        nzType="text"
                        nzDanger
                        type="button"
                        class="rule-delete-button"
                        (click)="removeRegexRule(i)"
                        [disabled]="regexRulesArray.length <= 1"
                        [nz-tooltip]="'common.delete' | i18n"
                        [testId]="'inbound-reason-create-regex-rule-delete-' + i"
                      >
                        <i nz-icon nzType="delete"></i>
                      </button>
                    </div>
                    <div
                      *ngIf="ruleCtrl.hasError('invalidRegex') && (ruleCtrl.dirty || ruleCtrl.touched)"
                      class="regex-rule-error"
                      [testId]="'inbound-reason-create-regex-rule-error-' + i"
                    >
                      {{ 'servicenumber.inbound-reason.form.regex-rules-invalid' | i18n }}
                    </div>
                  </div>

                  <div class="regex-rules-actions" [testId]="'inbound-reason-create-regex-rules-actions'">
                    <button
                      nz-button
                      nzType="dashed"
                      type="button"
                      class="add-rule-button"
                      (click)="addRegexRule()"
                      [disabled]="regexRulesArray.length >= 20"
                      [testId]="'inbound-reason-create-regex-rules-add-btn'"
                    >
                      <i nz-icon nzType="plus"></i>
                      {{ 'servicenumber.inbound-reason.form.regex-rules-add' | i18n }}
                    </button>
                  </div>
                </div>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
